import { render, staticRenderFns } from "./DtIndex.vue?vue&type=template&id=6439391c&"
import script from "./DtIndex.vue?vue&type=script&lang=js&"
export * from "./DtIndex.vue?vue&type=script&lang=js&"
import style0 from "./DtIndex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports